<div class="flex h-screen w-screen">
  <div class="flex h-full w-full flex-col items-center justify-center lg:max-w-[600px]">
    <div class="flex h-full w-full max-w-[450px] grow flex-col items-center justify-center gap-8 p-4">
      <pl-error-display *ngIf="!!error(); else loginShell" [error]="error()" />
      <ng-template #loginShell>
        <img src="assets/pl_logo_and_text_black.svg" alt="logo potentialife" class="h-[72px]" />

        <div class="w-full">
          <router-outlet></router-outlet>
        </div>
      </ng-template>
    </div>
    <pl-release-stage-display />
    <h6 class="d-inline-block">{{ version }}</h6>
  </div>
  <div class="custom-background hidden h-full grow lg:block"></div>
</div>
